import { useEffect, useState } from 'react';
import { listRelationRoles } from 'services/Settings';
import { totalCountEvent } from 'services/generalServices';

export function useRelationRole(practice_area = '') {
  const [List, setList] = useState([]);

  const loadRelationRoles = () => {
    totalCountEvent('relation_role').then((response) => {
      listRelationRoles(response.data, '', '', 'alphabet_ascending', practice_area, true).then((res) => {
        setList(res.data?.relation_role);
      });
    });
  };

  useEffect(() => {
    loadRelationRoles();
  }, [practice_area]);

  return { relationRoleList: List };
}
